import { render } from "./goods_resource_list.vue?vue&type=template&id=138d5141"
import script from "./goods_resource_list.vue?vue&type=script&lang=js"
export * from "./goods_resource_list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__